import { combineReducers } from 'redux';

const SET_SITE_SUBSCRIPTION = 'SET_SITE_SUBSCRIPTION';

const isWorking = (state = 0, action) => {
  switch (action.type) {
    case 'BEGIN_OPERATION': return state + 1;
    case 'END_OPERATION': return state - 1;
    default: return state;
  }
};

export const siteInfoInfoReducer = combineReducers({
  isWorking,
  initializing: (state = false, action) => (action.type === 'INITIALIZING' ? action.running : state),
  countryUser: (state = null, action) => (action.type === 'SET_COUNTRY' ? action.country : state),
  priceProduct: (state = null, action) => (action.type === 'SET_PRICE' ? action.price : state),
  product: (state = null, action) => (action.type === 'SET_PRODUCT' ? action.product : state),
  subscription: (state = null, action) => (action.type === SET_SITE_SUBSCRIPTION ? action.subscription : state),
  language: (state = null, action) => (action.type === 'SET_LANGUAGE' ? action.language : state),
  errorMessage: (state = null, action) => (action.type === 'SET_ERROR' ? action.error : state),
});

export const setSiteSubscription = (subscription) => ({ type: SET_SITE_SUBSCRIPTION, subscription });
